/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-01 15:49:26
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-25 17:05:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/slice/index.ts
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-17 17:36:16
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-25 16:49:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/index.ts
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-25 11:35:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/index.ts
 */

/**
 *  Sales Channel Content Reducer Set
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */

import {
  // createSlice,
  // createSelector,
  // createAsyncThunk,
  combineReducers,
} from '@reduxjs/toolkit';
import { EnumReducers } from './constants';
import customization from '../SalesChannelProductCustomization/slice';
import productContent from '../SalesChannelProductContent/slice';
import productAliasEdit from '../SalesChannelProductAlias/EditPage/slice';
import productAlias from '../SalesChannelProductAlias/ListPage/slice';
export { EnumReducers };
const salesChannelProductReducer = combineReducers({
  customization,
  productContent,
  productAliasEdit,
  productAlias,
});
export default salesChannelProductReducer;
